{
  "nl": {
    "surveys": {
      "buttons": {
        "addAnswer": "Optie toevoegen",
        "edit": "Klik om te bewerken",
        "moveQuestionDown": "Vraag naar beneden verplaatsen",
        "moveQuestionUp": "Vraag naar boven verplaatsen",
        "removeOption": "Optie verwijderen",
        "removeQuestion": "Vraag verwijderen"
      },
      "confirm": {
        "deleteQuestionText": "Deze actie kan niet ongedaan worden gemaakt. De vraag wordt samen met alle antwoordopties permanent uit de enquête verwijderd.",
        "deleteQuestionTitle": "Vraag verwijderen?",
        "requiredIncompleteText": "Je hebt nog niet alle verplichte velden (met *) ingevuld. Vul ze aan om de enquête te versturen.",
        "requiredIncompleteTitle": "Verplichte velden ontbreken",
        "submitIncompleteText": "Je hebt nog niet alle vragen beantwoord. Je antwoord wordt toch verzonden.",
        "submitIncompleteTitle": "Antwoord verzenden?"
      },
      "flash": {
        "questionAdded": "Vraag toegevoegd",
        "questionDeleted": "Vraag verwijderd",
        "questionMoved": "Vraag verplaatst",
        "questionUpdated": "Vraag bijgewerkt",
        "submitFailed": "Je antwoord kon niet worden verzonden. Probeer het opnieuw."
      },
      "headers": {
        "answers": "Resultaten",
        "general": "Titel en beschrijving",
        "lastAnswered": "Laatst beantwoord",
        "questions": "Vragen",
        "responsesPerQuestion": {
          "answers": "{count} antwoord | {count} antwoorden",
          "oClock": "uur",
          "of": "om",
          "responses": "{count} inzending | {count} inzendingen"
        },
        "shareResultsLink": "Deel deze link naar de resultaten van de enquête"
      },
      "hints": {
        "average": "Gemiddelde",
        "evaluations": "{count} beoordeling | {count} beoordelingen",
        "file": "Formuleer een werkopdracht waarvoor je leerlingen een bestand moeten uploaden (bijv. een tekstbestand, een afbeelding of een pdf).",
        "long_answer": "Stel een werkopdracht op waarvoor je leerlingen een antwoord in een tekstveld digitaal kunnen indienen.",
        "maxOptionsReached": "Er kunnen maximaal {max} opties worden toegevoegd.",
        "multiple_choice": "Stel een vraag en voer de antwoordmogelijkheden in. Er kan meer dan één antwoord worden geselecteerd.",
        "noDescriptionOrOptions": "Geen beschrijving of opties ingevuld",
        "notAnswered": "geen opgave",
        "rating": "Laat je leerlingen iets beoordelen met 1-5 sterren.",
        "required": "Vraag moet worden beantwoord",
        "single_choice": "Stel een vraag en voer de antwoordmogelijkheden in. Er kan slechts één antwoord worden geselecteerd.",
        "submitSuccessful": "Bedankt voor het deelnemen aan deze enquête."
      },
      "inserter": {
        "title": "Nieuw blok toevoegen"
      },
      "labels": {
        "backToResponseIndex": "Terug naar het overzicht",
        "loadingResponses": "Antwoorden worden geladen...",
        "required": "Verplicht veld",
        "showAllAnswers": "Details weergeven"
      },
      "placeholders": {
        "description": "Beschrijving toevoegen",
        "optionInput": "Optie hier invoeren...",
        "question": "Vraag",
        "title": "Titel hier invoeren..."
      },
      "questionTypes": {
        "file": "Bestand aanvragen",
        "long_answer": "Tekstantwoord",
        "multiple_choice": "Meerkeuze",
        "net_promoter_score": "Net Promoter Score (0-10)",
        "rating": "Beoordeling",
        "single_choice": "Enkele keuze"
      },
      "tabs": {
        "submissions": "Inzendingen",
        "survey": "Enquête"
      }
    }
  }
}
